// Theme: cobalt-reactor
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'cobalt-reactor',
  name: 'COBALT REACTOR',
  tagline: 'COBALT REACTOR',
  description: 'Azul industrial de nucleo reativo com energia controlada.',
  category: 'neon-cyber',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#060D1A', '#0E1E38', '#3B82F6', '#EFF6FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '2px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.30)',
      '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 55%, transparent)'
    },
    shellClasses: 'font-mono theme-cobalt-reactor'
  },
  colorVars: {
    '--accent': '#3B82F6',
    '--accent-foreground': '#060D1A',
    '--background': '#060D1A',
    '--border': '#1E40AF',
    '--card': '#0E1E38',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 70%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#EFF6FF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 12%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#060D1A',
    '--foreground': '#EFF6FF',
    '--hold-fill': '#3B82F6',
    '--input': '#1E40AF',
    '--modal-bg': '#060D1A',
    '--modal-border': '#1E40AF',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.30)',
    '--muted': '#1E40AF',
    '--muted-foreground': '#BFDBFE',
    '--nav-active': '#3B82F6',
    '--nav-bg': '#0E1E38',
    '--popover': '#0E1E38',
    '--popover-foreground': '#EFF6FF',
    '--primary': '#3B82F6',
    '--primary-foreground': '#060D1A',
    '--ring': '#3B82F6',
    '--secondary': '#1E40AF',
    '--secondary-foreground': '#EFF6FF',
    '--streak': '#3B82F6',
    '--success': '#22c55e',
    '--success-foreground': '#060D1A',
    '--xp': '#3B82F6',
    '--xp-bg': '#0E1E38'
  },
  resolvedVars: {
    '--accent': '#3B82F6',
    '--accent-foreground': '#060D1A',
    '--accent-foreground-hsl': '219 63% 6%',
    '--accent-foreground-oklch': 'from #060D1A l c h',
    '--accent-hsl': '217 91% 60%',
    '--accent-oklch': 'from #3B82F6 l c h',
    '--background': '#060D1A',
    '--background-hsl': '219 63% 6%',
    '--background-oklch': 'from #060D1A l c h',
    '--border': '#1E40AF',
    '--border-hsl': '226 71% 40%',
    '--border-oklch': 'from #1E40AF l c h',
    '--border-w': '1px',
    '--card': '#0E1E38',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 70%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#EFF6FF',
    '--card-foreground-hsl': '214 100% 97%',
    '--card-foreground-oklch': 'from #EFF6FF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 12%, transparent)',
    '--card-hsl': '217 60% 14%',
    '--card-oklch': 'from #0E1E38 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#060D1A',
    '--destructive-foreground-hsl': '219 63% 6%',
    '--destructive-foreground-oklch': 'from #060D1A l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#EFF6FF',
    '--foreground-hsl': '214 100% 97%',
    '--foreground-oklch': 'from #EFF6FF l c h',
    '--hold-fill': '#3B82F6',
    '--hold-fill-hsl': '217 91% 60%',
    '--hold-fill-oklch': 'from #3B82F6 l c h',
    '--input': '#1E40AF',
    '--input-hsl': '226 71% 40%',
    '--input-oklch': 'from #1E40AF l c h',
    '--modal-bg': '#060D1A',
    '--modal-bg-hsl': '219 63% 6%',
    '--modal-bg-oklch': 'from #060D1A l c h',
    '--modal-border': '#1E40AF',
    '--modal-border-hsl': '226 71% 40%',
    '--modal-border-oklch': 'from #1E40AF l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.30)',
    '--muted': '#1E40AF',
    '--muted-foreground': '#BFDBFE',
    '--muted-foreground-hsl': '213 97% 87%',
    '--muted-foreground-oklch': 'from #BFDBFE l c h',
    '--muted-hsl': '226 71% 40%',
    '--muted-oklch': 'from #1E40AF l c h',
    '--nav-active': '#3B82F6',
    '--nav-active-hsl': '217 91% 60%',
    '--nav-active-oklch': 'from #3B82F6 l c h',
    '--nav-bg': '#0E1E38',
    '--nav-bg-hsl': '217 60% 14%',
    '--nav-bg-oklch': 'from #0E1E38 l c h',
    '--popover': '#0E1E38',
    '--popover-foreground': '#EFF6FF',
    '--popover-foreground-hsl': '214 100% 97%',
    '--popover-foreground-oklch': 'from #EFF6FF l c h',
    '--popover-hsl': '217 60% 14%',
    '--popover-oklch': 'from #0E1E38 l c h',
    '--primary': '#3B82F6',
    '--primary-foreground': '#060D1A',
    '--primary-foreground-hsl': '219 63% 6%',
    '--primary-foreground-oklch': 'from #060D1A l c h',
    '--primary-hsl': '217 91% 60%',
    '--primary-oklch': 'from #3B82F6 l c h',
    '--radius': '2px',
    '--ring': '#3B82F6',
    '--ring-hsl': '217 91% 60%',
    '--ring-oklch': 'from #3B82F6 l c h',
    '--secondary': '#1E40AF',
    '--secondary-foreground': '#EFF6FF',
    '--secondary-foreground-hsl': '214 100% 97%',
    '--secondary-foreground-oklch': 'from #EFF6FF l c h',
    '--secondary-hsl': '226 71% 40%',
    '--secondary-oklch': 'from #1E40AF l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.30)',
    '--shadow-card-active': '0 0 24px color-mix(in srgb, var(--primary) 55%, transparent)',
    '--streak': '#3B82F6',
    '--streak-hsl': '217 91% 60%',
    '--streak-oklch': 'from #3B82F6 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#060D1A',
    '--success-foreground-hsl': '219 63% 6%',
    '--success-foreground-oklch': 'from #060D1A l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(217 91% 60% / 0.15)',
    '--xp': '#3B82F6',
    '--xp-bg': '#0E1E38',
    '--xp-bg-hsl': '217 60% 14%',
    '--xp-bg-oklch': 'from #0E1E38 l c h',
    '--xp-hsl': '217 91% 60%',
    '--xp-oklch': 'from #3B82F6 l c h'
  }
}
